import { FlowId } from '@constants/flows';
import { fork, cancel, take } from 'redux-saga/effects';
import { startFlow, stopFlow } from '../actions/flows';
import exampleFlow from './exampleFlow';

const sagaMap = {
  [FlowId.EXAMPLE]: exampleFlow,
};

export default function createFlowsSaga() {
  return function* flowsSaga() {
    let flowTask;

    while (true) {
      const { type, payload } = yield take([startFlow.type, stopFlow.type]);

      // cancel any existing saga - only allow one to run at a time
      if (flowTask) {
        yield cancel(flowTask);
        flowTask = null;
      }
      if (type === startFlow.type) {
        const { flowId, options } = payload;
        const flowSaga = sagaMap[flowId];

        if (flowSaga) flowTask = yield fork(flowSaga, options);
      }
    }
  };
}
